<cxone-modal [headerTitle]="modalTitle" [focusOnShow]="true" [saveHidden]="true" [customFooter]="true"
    (closed)="onClose()" (dismissed)="onClose()" id="view-reason-modal" #modalDialog>
    <div class="content">
        <pre>
            <code>{{content}}</code>
        </pre>
    </div>
    <cxone-modal-footer>
        <button class="cxone-btn btn-medium btn-primary cancel-btn" (click)="onClose()" id="cancel-btn">{{cancelLabel}}</button>
    </cxone-modal-footer>
</cxone-modal>